import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * Remove Icon from Figma
 * @link [Figma](https://www.figma.com/file/bUeKiC8YcV9PHrMlJAZUJG/Design-System?node-id=1331%3A8099&mode=dev)
 * */

const SyncIcon = props => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_1331_8099)" className="stroke-current" strokeLinecap="round"><path d="M4.032 7.313H.75v3.28" /><path d="M10.739 7.954a4.875 4.875 0 01-9.396-.641" strokeLinejoin="round" /><path d="M7.968 4.688h3.281v-3.28" /><path d="M1.261 4.047a4.875 4.875 0 019.396.641" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <defs><clipPath id="clip0_1331_8099"><path d="M0 0H12V12H0z" /></clipPath></defs>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <Svg width={12} height={12} {...props}>{t0}{t1}</Svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default SyncIcon;